import { defineStore } from 'pinia'

let interval = null

export const useUploadBlockStore = defineStore('uploadBlock', {
    state: () => ({
        blockedUntil: Number(localStorage.getItem('upload_blocked_until')) || 0,
        remaining: 0,
    }),

    getters: {
        isBlocked: (state) => state.remaining > 0,

        remainingText: (state) => {
            const min = Math.floor(state.remaining / 60)
            const sec = state.remaining % 60

            return `${min}:${String(sec).padStart(2, '0')}`
        }
    },

    actions: {
        init() {
            this.updateRemaining()

            if (!interval) {
                interval = setInterval(() => {
                    this.updateRemaining()
                }, 1000)
            }
        },

        updateRemaining() {
            if (!this.blockedUntil) {
                this.remaining = 0
                return
            }

            const remain = Math.ceil((this.blockedUntil - Date.now()) / 1000)

            if (remain <= 0) {
                this.clear()
            } else {
                this.remaining = remain
            }
        },

        block(seconds) {
            this.blockedUntil = Date.now() + seconds * 1000
            this.remaining = seconds

            localStorage.setItem(
                'upload_blocked_until',
                this.blockedUntil
            )
        },

        clear() {
            this.blockedUntil = 0
            this.remaining = 0

            localStorage.removeItem('upload_blocked_until')
        }
    }
})
